"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
var messages = (0, react_intl_1.defineMessages)({
    taskDetails: {
        id: 'general.taskDetails',
        defaultMessage: 'Task details',
        description: 'Task details',
    },
    machines: {
        id: 'general.machines',
        defaultMessage: 'Machines',
        description: 'Machines',
    },
    implements: {
        id: 'general.implements',
        defaultMessage: 'Implements',
        description: 'Implements',
    },
    team: {
        id: 'general.team',
        defaultMessage: 'Team',
        description: 'Team',
    },
    backToList: {
        id: 'general.backToList',
        defaultMessage: 'Back to list',
        description: 'Back to list',
    },
    close: {
        id: 'general.close',
        defaultMessage: 'Close',
        description: 'Close',
    },
    name: {
        id: 'general.name',
        defaultMessage: 'Name',
        description: 'Name',
    },
    startDateShort: {
        id: 'general.startDate.short',
        defaultMessage: 'Start',
        description: 'Start for dates',
    },
    endDateShort: {
        id: 'general.endDate.short',
        defaultMessage: 'End',
        description: 'End for dates',
    },
    customer: {
        id: 'general.customer',
        defaultMessage: 'Customer',
        description: 'Customer',
    },
    farm: {
        id: 'general.farm',
        defaultMessage: 'Farm',
        description: 'Farm',
    },
    vin: {
        id: 'general.vinNumber.short',
        defaultMessage: 'VIN',
        description: 'Vin number short',
    },
    learnMore: {
        id: 'general.learnMore',
        defaultMessage: 'Learn more',
        description: 'Learn more',
    },
    cancel: {
        id: 'general.cancel',
        defaultMessage: 'Cancel',
        description: 'Cancel',
    },
    download: {
        id: 'general.download',
        defaultMessage: 'Download',
        description: 'Download',
    },
    select: {
        id: 'general.select',
        defaultMessage: 'Select',
        description: 'Select',
    },
    selected: {
        id: 'general.selected',
        defaultMessage: 'Selected',
        description: 'Selected',
    },
    deselect: {
        id: 'general.deselect',
        defaultMessage: 'Deselect',
        description: 'Deselect',
    },
    import: {
        id: 'general.import',
        defaultMessage: 'Import',
        description: 'Import',
    },
    date: {
        id: 'general.date',
        defaultMessage: 'Date',
        description: 'Date',
    },
    next: {
        id: 'general.next',
        defaultMessage: 'Next',
        description: 'Next',
    },
    previous: {
        id: 'general.previous',
        defaultMessage: 'Previous',
        description: 'Previous',
    },
    skip: {
        id: 'general.skip',
        defaultMessage: 'Skip',
        description: 'Skip',
    },
    save: {
        id: 'general.save',
        defaultMessage: 'Save',
        description: 'Save',
    },
    saveAndContinue: {
        id: 'general.saveAndContinue',
        defaultMessage: 'Save & Continue',
        description: 'Save & Continue',
    },
    discard: {
        id: 'general.discard',
        defaultMessage: 'Discard',
        description: 'Discard',
    },
    edit: {
        id: 'general.edit',
        defaultMessage: 'Edit',
        description: 'Edit',
    },
    manage: {
        id: 'general.manage',
        defaultMessage: 'Manage',
        description: 'Manage',
    },
    change: {
        id: 'general.change',
        defaultMessage: 'Change',
        description: 'Change',
    },
    back: {
        id: 'general.back',
        defaultMessage: 'Back',
        description: 'Back',
    },
    confirm: {
        id: 'general.confirm',
        defaultMessage: 'Confirm',
        description: 'Confirm',
    },
    continue: {
        id: 'general.continue',
        defaultMessage: 'Continue',
        description: 'Continue',
    },
    email: {
        id: 'general.email.label',
        defaultMessage: 'Email',
        description: 'Email',
    },
    verify: {
        id: 'general.verify',
        defaultMessage: 'Verify',
        description: 'Verify',
    },
    password: {
        id: 'general.password',
        defaultMessage: 'Password',
        description: 'Password',
    },
    passwordConfirm: {
        id: 'general.passwordConfirm',
        defaultMessage: 'Confirm password',
        description: 'Confirm password',
    },
    choosePassword: {
        id: 'general.choosePassword',
        defaultMessage: 'Choose password',
        description: 'Choose password',
    },
    changePassword: {
        id: 'general.changePassword',
        defaultMessage: 'Change password',
        description: 'Change password',
    },
    salutation: {
        id: 'general.salutation',
        defaultMessage: 'Salutation',
        description: 'Salutation',
    },
    firstName: {
        id: 'general.firstName',
        defaultMessage: 'First name',
        description: 'First name',
    },
    lastName: {
        id: 'general.lastName',
        defaultMessage: 'Last name',
        description: 'Last name',
    },
    address: {
        id: 'general.address',
        defaultMessage: 'Address',
        description: 'Address',
    },
    city: {
        id: 'general.city',
        defaultMessage: 'City/Location',
        description: 'City/Location',
    },
    state: {
        id: 'general.state',
        defaultMessage: 'State',
        description: 'State',
    },
    stateProvince: {
        id: 'general.stateProvince',
        defaultMessage: 'State / Province',
        description: 'State / Province',
    },
    postalCode: {
        id: 'general.postalCode',
        defaultMessage: 'Postal code',
        description: 'Postal code',
    },
    country: {
        id: 'general.country',
        defaultMessage: 'Country',
        description: 'Country',
    },
    mobilePhoneNum: {
        id: 'general.mobilePhoneNum',
        defaultMessage: 'Mobile phone number',
        description: 'Mobile phone number',
    },
    officePhoneNum: {
        id: 'general.officePhoneNum',
        defaultMessage: 'Office phone number',
        description: 'Office phone number',
    },
    confirmation: {
        id: 'general.confirmation',
        defaultMessage: 'Confirmation',
        description: 'Confirmation',
    },
    privacyStatement: {
        id: 'general.privacyStatement',
        defaultMessage: 'Privacy Statement',
        description: 'Privacy Statement',
    },
    apiError: {
        id: 'general.apiError',
        defaultMessage: 'An unknown error occurred during serving the request.',
        description: 'General api error',
    },
    paginationDropdown: {
        id: 'general.paginationDropdown',
        defaultMessage: 'Rows per page',
        description: 'Define number of rows per page',
    },
    reload: {
        id: 'general.reload',
        defaultMessage: 'Reload',
        description: 'Reload',
    },
    unsavedChanges: {
        id: 'general.unsavedChanges',
        defaultMessage: 'Leave without saving changes',
        description: 'Unsaved changes',
    },
    unsavedChangesDescription: {
        id: 'general.unsavedChanges.description',
        defaultMessage: 'Your changes will not be saved.{lineBreak}Do you want to discard them and leave?',
        description: 'Changes that you made may not be saved.',
    },
    leave: {
        id: 'general.leave',
        defaultMessage: 'Leave',
        description: 'Leave',
    },
    selectDate: {
        id: 'general.selectDate',
        defaultMessage: 'Select date',
        description: 'Select date',
    },
    browseFiles: {
        id: 'general.browseFiles',
        defaultMessage: 'Browse files',
        description: 'Browse files',
    },
    documentType: {
        id: 'general.documentType',
        defaultMessage: 'Document type',
        description: 'Document type',
    },
    tryAgain: {
        id: 'general.tryAgain',
        defaultMessage: 'Try again',
        description: 'Try again',
    },
    uploadFailed: {
        id: 'general.uploadFailed',
        defaultMessage: 'Upload failed',
        description: 'Upload failed',
    },
    submit: {
        id: 'general.submit',
        defaultMessage: 'Submit',
        description: 'Submit',
    },
    invalidDate: {
        id: 'general.invalidDate',
        defaultMessage: 'Please enter a valid year',
        description: 'Invalid date',
    },
    noFutureDates: {
        id: 'general.noFutureDates',
        defaultMessage: 'Please do not enter a future year',
        description: 'No future dates',
    },
    purchaseAfterManufcaturingDate: {
        id: 'general.purchaseAfterManufcatureDate',
        defaultMessage: 'Purchase date needs to be after manufacture date',
        description: 'Purchase date after manufacturing date',
    },
    alphanumericCharactersOnly: {
        id: 'general.alphanumericCharactersOnly',
        defaultMessage: 'Please only use alphanumeric characters',
        description: 'Validation message for fields requiring alphanumeric characters only',
    },
    dndClickToUpload: {
        id: 'general.dnd.clickToUpload',
        defaultMessage: 'Click to upload',
        description: 'updloading documents dnd click to upload',
    },
    dndOrDragAndDrop: {
        id: 'general.dnd.orDragAndDrop',
        defaultMessage: 'or drag and drop',
        description: 'updloading documents dnd or drag and drop',
    },
    maxFileSize: {
        id: 'general.maxFileSize',
        defaultMessage: 'Max. {size} per file',
        description: 'Max. {size} per file',
    },
    maxFileSizeSingle: {
        id: 'general.maxFileSizeSingle',
        defaultMessage: 'Max. {size}',
        description: 'Max. {size}',
    },
    uploadFailedFileTypeNotSupported: {
        id: 'general.uploadFailed.fileTypeNotSupported',
        defaultMessage: 'Upload failed, filetype is not supported',
        description: 'Upload failed, filetype is not supported',
    },
    uploadFailedFileSizeExceeded: {
        id: 'general.uploadFailed.fileSizeExceeded',
        defaultMessage: 'The limit for the file size has been exceeded.',
        description: 'Upload failed, filesize exceeded',
    },
    fileTypes: {
        id: 'general.supportedFileTypes',
        defaultMessage: 'Unsupported file format. Please upload a valid {fileTypes} file.',
        description: 'Supported file types {fileTypes}',
    },
    chooseMaxFiles: {
        id: 'general.chooseMaxFiles',
        defaultMessage: 'Choose up to {maxFiles} files',
        description: 'Choose up to {maxFiles} files',
    },
    details: {
        id: 'general.details',
        defaultMessage: 'Details',
        description: 'Details',
    },
    delete: {
        id: 'general.delete',
        defaultMessage: 'Delete',
        description: 'Delete',
    },
    invalidFileType: {
        id: 'general.invalidFileType',
        defaultMessage: 'Invalid file type',
        description: 'Invalid file type',
    },
    deleteSomething: {
        id: 'general.deleteSomething',
        defaultMessage: 'Delete {something}',
        description: 'Delete something',
    },
    renameSomething: {
        id: 'general.renameSomething',
        defaultMessage: 'Rename {something}',
        description: 'Rename something',
    },
    remindMeLater: {
        id: 'general.remindMeLater',
        defaultMessage: 'Remind me later',
        description: 'Remind me later',
    },
    go: {
        id: 'general.go',
        defaultMessage: 'Go',
        description: 'Go',
    },
    selectPlaceholder: {
        id: 'general.selectPlaceholder',
        defaultMessage: 'Select...',
        description: 'Select placeholder',
    },
    open: {
        id: 'general.open',
        defaultMessage: 'Open',
        description: 'Open',
    },
    on: {
        id: 'general.on',
        defaultMessage: 'On',
        description: 'On',
    },
    off: {
        id: 'general.off',
        defaultMessage: 'Off',
        description: 'Off',
    },
    ok: {
        id: 'general.ok',
        defaultMessage: 'Ok',
        description: 'OK',
    },
    inactivityModalTitle: {
        id: 'general.inactivityModalTitle',
        defaultMessage: 'Session Timeout Alert',
        description: 'Inactivity modal title',
    },
    inactivityModalDescription: {
        id: 'general.inactivityModalDescription',
        defaultMessage: 'You will be logged out in {inactiveTimeInMin} minutes due to inactivity. Click OK or perform any activity to remain logged in.',
        description: 'Inactivity modal description',
    },
    enter: {
        id: 'general.enter',
        defaultMessage: 'Enter',
        description: 'Enter',
    },
    uploadFailedMaxFilesError: {
        id: 'general.uploadFailedMaxFilesError',
        defaultMessage: 'You can upload up to {maxFiles} files total. Please choose less files or remove some files before adding more.',
        description: 'Max files',
    },
    fileSizeExceedsLimit: {
        id: 'general.fileSizeExceedsLimit',
        defaultMessage: 'File size exceeds the maximum allowed limit of {size}. Please choose a smaller file.',
        description: 'File size exceeds limit message',
    },
    siteUnderMaintenance: {
        id: 'general.siteUnderMaintenance',
        defaultMessage: 'Site is under maintenance',
        description: 'Site is under maintenance',
    },
    siteUnderMaintenanceDescription: {
        id: 'general.siteUnderMaintenance.description',
        defaultMessage: 'Our website is currently undergoing scheduled maintenance. We apologize for any inconvenience and appreciate your patience. Please check back later. Thank you for understanding!',
        description: 'Site is under maintenance description',
    },
    title: {
        id: 'general.title',
        defaultMessage: 'Title',
        description: 'Title',
    },
    description: {
        id: 'general.description',
        defaultMessage: 'Description',
        description: 'Description',
    },
    skipToMainContent: {
        id: 'general.skipToMainContent',
        defaultMessage: 'Skip to main content',
        description: 'Skip to main content',
    },
    new: {
        id: 'general.new',
        defaultMessage: 'New',
        description: 'New',
    },
    newFeatureAvailable: {
        id: 'general.newFeatureAvailable',
        defaultMessage: 'New feature available',
        description: 'New feature available',
    },
    newFeatureAlert: {
        id: 'general.newFeatureAlert',
        defaultMessage: 'New Feature Alert!',
        description: 'New feature alert',
    },
    newFeatureAlertDescription: {
        id: 'general.newFeatureAlertDescription',
        defaultMessage: "We've added a new feature to enhance your experience.{lineBreak}Check it out now to see what's new.",
        description: 'New feature alert description',
    },
});
exports.default = messages;
